module.exports = __webpack_public_path__ + "static/media/eighteen-semi-transportation-svgrepo-com.89f902fb.svg";